import type { CambioTabla } from '../types/api';

const TIPO: Record<CambioTabla['tipo'], string> = {
  alta: 'Nueva',
  baja: 'Quitada',
  cambio: 'Cambiada',
  desactivacion: 'Desactivada',
  reactivacion: 'Reactivada',
};

function valor(v: unknown): string {
  if (v === null || v === undefined) return '—';
  if (typeof v === 'boolean') return v ? 'sí' : 'no';
  return String(v);
}

/** Cambios de una versión respecto a la anterior. Las altas de la semilla se resumen. */
export function DiffVista({ cambios, resumirAltas = false }: { cambios: CambioTabla[]; resumirAltas?: boolean }) {
  if (cambios.length === 0) return <p className="vacio">Sin cambios respecto a la versión anterior.</p>;
  if (resumirAltas && cambios.every((c) => c.tipo === 'alta')) {
    return <p>Configuración inicial: {cambios.length} tablas ({cambios.map((c) => c.tabla).join(', ')}).</p>;
  }
  return (
    <div className="diff">
      {cambios.map((c) => (
        <section key={c.tabla} className={`diff-tabla diff-${c.tipo}`}>
          <h3>
            {c.tabla} <span className="diff-tipo">{TIPO[c.tipo]}</span>
          </h3>
          <table className="tabla">
            <thead>
              <tr>
                <th>Campo</th>
                <th>Antes</th>
                <th>Después</th>
              </tr>
            </thead>
            <tbody>
              {c.campos.map((f) => (
                <tr key={f.campo}>
                  <td>
                    <code>{f.campo}</code>
                  </td>
                  <td className="antes">{valor(f.antes)}</td>
                  <td className="despues">{valor(f.despues)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
      ))}
    </div>
  );
}
